module.exports = __webpack_public_path__ + "static/media/pic17.31f8f3e6.jpg";